/** Fetch remote bytes before invoking Save, so HTTP and network errors remain observable. */
export async function saveFileDownload(source: string | Blob, fileName: string): Promise<void> {
  let file: Blob;
  if (typeof source === "string") {
    let response: Response;
    try {
      response = await fetch(source, { credentials: "omit", signal: AbortSignal.timeout(120_000) });
    } catch {
      throw new Error(
        "The file could not be fetched. Check your connection or browser security settings and try again.",
      );
    }
    if (!response.ok) {
      throw new Error(
        `The file server could not provide this download (HTTP ${response.status}). Try again to request a fresh link.`,
      );
    }
    if (
      response.headers.get("content-type")?.includes("text/html") &&
      !/\.html?$/i.test(fileName)
    ) {
      throw new Error(
        "The download returned a web page instead of the file. A sign-in or security filter may be blocking it.",
      );
    }
    try {
      file = await response.blob();
    } catch {
      throw new Error(
        "The download was interrupted before the file finished loading. Please try again.",
      );
    }
  } else {
    file = source;
  }
  const url = URL.createObjectURL(file);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.append(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
    // Browsers consume the Blob asynchronously after the click returns.
    setTimeout(() => URL.revokeObjectURL(url), 30_000);
  }
}
